import { createCardPagination } from './create_test';
import { 
    setCardPaginationVisible, 
    setCardPaginationId, 
    getNextCardPaginationId,
    setCardPaginationAllpks,
    addEventListener,
    setCardPaginationActiveId,
} from './methods_test';

export default {
    createCardPagination,
    setCardPaginationVisible, 
    setCardPaginationId, 
    getNextCardPaginationId,
    setCardPaginationAllpks,
    addEventListener,
    setCardPaginationActiveId,
};